import { Modal as BootstrapModal } from "bootstrap";

export default class Modal {
    modalElement: HTMLElement;
    constructor(private modalId: string, private delay: number, private isAutoActivate: boolean) {
        this.modalElement = document.getElementById(this.modalId);
        if (!this.modalElement)
            return;
        if (this.isAutoActivate == true) 
            this.awaitModalOrder();
        
        window.addEventListener('beforeunload', () => this.handleBeforeUnload());
        this.initFocusTrap();
    }

    private awaitModalOrder(): void {
        const checkActiveModal = () => {
            const activeModalId = sessionStorage.getItem('activeModalId');
            if (!activeModalId) {
                sessionStorage.setItem('activeModalId', this.modalId);
                this.showModal();
            } else {
                setTimeout(checkActiveModal, 500);
            }
        };

        checkActiveModal();
    }

    private showModal(): void {
        const modal = new BootstrapModal(this.modalElement);

        this.modalElement.addEventListener('shown.bs.modal', () =>
            this.modalElement.querySelector<HTMLButtonElement>('.close-modal')?.focus() // Set focus on the close button
        );

        setTimeout(() => modal.show(), this.delay);

        this.modalElement.addEventListener('hidden.bs.modal', () =>
            this.clearActiveModal()
        );
    }

    private clearActiveModal(): void {
        if (sessionStorage.getItem('activeModalId') === this.modalId) {
            sessionStorage.removeItem('activeModalId');
        }
    }

    private initFocusTrap(): void {
        const focusableEls = this.modalElement.querySelectorAll<HTMLElement>('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
        const firstFocusableEl = focusableEls[0];
        const lastFocusableEl = focusableEls[focusableEls.length - 1];
        function handleKeyDown(e: KeyboardEvent) {
            const isTabPressed = e.key === 'Tab';
            if (!isTabPressed) {
                return;
            }

            if (e.shiftKey) /* shift + tab */ {
                if (document.activeElement === firstFocusableEl) {
                    lastFocusableEl.focus();
                    e.preventDefault();
                }
            } else /* tab */ {
                if (document.activeElement === lastFocusableEl) {
                    firstFocusableEl.focus();
                    e.preventDefault();
                }
            }
        }

        this.modalElement.addEventListener('keydown', handleKeyDown);
    };

    private handleBeforeUnload(): void {
        this.clearActiveModal();
    }

    public redirectOnClose(url: string) {

        this.modalElement.addEventListener('hidden.bs.modal', () =>
            window.location.href = url
        );
    }
}